import { jwtDecode } from 'jwt-decode';
import { AuthProvider } from 'react-admin';

const authProvider: AuthProvider = {
  login: () => {
    if (localStorage.getItem('token')) {
      return Promise.resolve();
    }
    return Promise.reject();
  },
  logout: () => {
    localStorage.removeItem('username');
    return Promise.resolve();
  },
  checkAuth: () =>
    localStorage.getItem('token') ? Promise.resolve() : Promise.reject(),
  checkError: (error) => {
    const { status } = error;
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  getIdentity: () => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const { id, firstName, lastName } = jwtDecode(token);

      const fullName = `${firstName} ${lastName}`;

      return Promise.resolve({
        id,
        fullName,
      });
    }
    return Promise.reject();
  },

  getPermissions: () => {
    if (localStorage.getItem('token')) {
      const token = localStorage.getItem('token');
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const { role } = jwtDecode(token);

      return Promise.resolve(role);
    }
    return Promise.reject();
  },
};

export default authProvider;
